/*
@description: This is file contains all backend API end points
*/

/******************Base URl**********************/
export const BASE_URL = `${process.env.REACT_APP_BACKEND_API_URL_PROD}`;

/******************User**********************/
export const USER = {
  login: "/admin/authenticate/admin-user",
  getOtp: "/admin/authenticate/get-otp",
  validateOtp: "/admin/authenticate/validate-otp",
  updatePassword: "/admin/authenticate/update-password",
  userLogout: "/admin/authenticate/destroy-session",
  GET_STATE_CITY: "/admin/mmtc/get-state-city",
  RESET_PASSWORD: "/admin/dashboard/reset-password",
};

/******************Employee**********************/
export const EMPLOYEE = {
  createEmployee: "/admin/employees",
  getAllEmployee: "/admin/employees/get-all",
  getEmployeeDetailsById: "/admin/employees/?id",
  updateEmployeeById: "/admin/employees/update-employee/?id",
  deactivateEmployee: "/admin/employees/?id",
  deleteEmployee: "/admin/employees/?id",
};

/******************Customers**********************/
export const CUSTOMERS = {
  getAllCustomers: "/admin/customers/get-all",
  deactivateCustomer: "/admin/customers/?id",
  getCustomerById: "/admin/customers/?id",
  updateCustomerById: "/admin/customers/update-customer/?id",
};

/******************Roles**********************/
export const ROLES = {
  getAllRoles: "/admin/roles/get-all",
  getRoleById: "/admin/roles/?id",
  GET_ROLE_PERMISSIONS: "/admin/roles/get-permissions",
};

/******************transactions**********************/
export const TRANSACTIONS = {
  getAllTransactions: "/admin/transactions",
  getTransactionById: "/admin/transactions/?trx_id",
};
/******************Notification**********************/
export const NOTIFICATION = {
  getAllNotification: "/admin/notifications/get-all",
  createNotification: "/admin/notifications",
  getNotificationById: "/admin/notifications",
};

/******************Search**********************/
export const SEARCH = {
  ADMIN_SEARCH: "/admin/search",
  ADMIN_SEARCH_TRANSACTION: "/admin/search_transaction",
  

};

/******************Dashboard**********************/
export const DASHBOARD = {
  currentGoldPrice: "/admin/mmtc/current-gold-price",
  historicalGoldPrice: "/admin/mmtc/historical-gold-price",
  totalUsers: "/admin/dashboard/users",
  totalSales: "/admin/dashboard/sales",
  totalrewardReceived: "/admin/dashboard/reward-received",
  totalrewardRedeemption: "/admin/dashboard/reward-redeemption",
  recentCustomers: "/admin/dashboard/recent-customers",
  SALES_HISTORY: "/admin/dashboard/sales-history",
  recentTransaction: "/admin/dashboard/recent-transactions",
};

/******************Reports**********************/
export const REPORTS = {
  DAILY_POINTS: "/admin/reports/daily-points",
  REWARD_REDEEM: "/admin/reports/reward-redeem",
  SUBSCRIBED_CUSTOMER: "/admin/reports/subs-customer",
  CUSTOMER: "/admin/reports/customer",
  OFFLINE_GOLD_TRANSACTION: "/admin/reports/gold-purchase",
  SUBSCRIPTION: "/admin/reports/subscription",
  ALL_TRANSACTION: "/admin/reports/all-trx",
};

/******************Instore Request**********************/
export const INSTOREREQUEST = {
  getAllRequest: "/admin/redeem_requests/in_store_requests",
  createAcceptReuqest: "/admin/redeem_requests/approve_reject_requests", 
};

/******************Delete Account**********************/

  export const DELETE_ACCOUNT = {
    deleteAccount: "/mobile/settings/delete-account",
    generateOtp: "/mobile/otp/generate",
    validateOtp: "/mobile/otp/validate",
    deleteRedeem: "/mobile/redeem" 

  };